/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logic': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" _fill="#C4FFF9" fill-rule="nonzero" d="M49.305 95.395l-5.305 5.3-5.304-5.3-5.301 5.3 5.3 5.306-5.3 5.304 5.3 5.301 5.305-5.3 5.305 5.3 5.3-5.3-5.3-5.305 5.3-5.305zM101.348 106l-5.3-5.305L90.742 106l10.605 10.605 15.91-15.91-5.305-5.3zM74 57.25c6.203 0 11.25-5.047 11.25-11.25S80.203 34.75 74 34.75 62.75 39.797 62.75 46 67.797 57.25 74 57.25zm0-15A3.756 3.756 0 0 1 77.75 46 3.756 3.756 0 0 1 74 49.75 3.756 3.756 0 0 1 70.25 46 3.756 3.756 0 0 1 74 42.25zM101.5 91h5V78.5H89.59L76.5 71.953V61h-5v10.953L58.41 78.5H41.5V91h5v-7.5h11.91L74 91.297 89.59 83.5h11.91V91zM74 85.703L64.59 81 74 76.297 83.41 81 74 85.703z"/></g>'
  }
})
